
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$form.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$form.js';
export default __default__;
